import { render, staticRenderFns } from "./UpdateCargadorDialogComponent.vue?vue&type=template&id=2b1570a0"
import script from "./UpdateCargadorDialogComponent.vue?vue&type=script&lang=js"
export * from "./UpdateCargadorDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports